import { render, staticRenderFns } from "./bsj-set-driver-vehicleinfo-registrationnum-modal.vue?vue&type=template&id=3dc9c880&"
import script from "./bsj-set-driver-vehicleinfo-registrationnum-modal.vue?vue&type=script&lang=js&"
export * from "./bsj-set-driver-vehicleinfo-registrationnum-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports